import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type { IAffiliatesRequestHistoryListItem } from '../types';
import {
  AFFILIATES_REQUEST_HISTORY_LIST_QUERY_KEY,
  AFFILIATES_REQUEST_HISTORY_LIST_URL,
  AFFILIATES_REQUEST_HISTORY_PERMISSIONS,
} from '../constants';

export default function useAffiliatesRequestHistoryListQuery(
  tableState: Ref<ITableState>,
): IContextQueryResult<ITableDataResponse<IAffiliatesRequestHistoryListItem>, Error> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<IAffiliatesRequestHistoryListItem>>({
    queryKey: [AFFILIATES_REQUEST_HISTORY_LIST_QUERY_KEY, tableState],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<IAffiliatesRequestHistoryListItem>>(
      AFFILIATES_REQUEST_HISTORY_LIST_URL,
      tableState.value,
      {
        signal,
        permission: AFFILIATES_REQUEST_HISTORY_PERMISSIONS.SHOW,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
